import { render, staticRenderFns } from "./Barcode.vue?vue&type=template&id=f5ae850c&scoped=true"
import script from "./Barcode.vue?vue&type=script&lang=js"
export * from "./Barcode.vue?vue&type=script&lang=js"
import style0 from "./Barcode.vue?vue&type=style&index=0&id=f5ae850c&prod&lang=scss&scoped=true"
import style1 from "./Barcode.vue?vue&type=style&index=1&id=f5ae850c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ae850c",
  null
  
)

export default component.exports